import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): Record<string, string | null> => state.experiments;
